import { useEffect } from "react";
import Breadcrumb from "../components/Breadcrumb";
// import CertificateTwo from "../components/CertificateTwo";
import FooterThree from "../components/FooterThree";
import HeaderOne from "../components/HeaderOne";
import InfoSectionOne from "../components/InfoSectionOne";
import JoinCommunityOne from "../components/JoinCommunityOne";
import Animation from "../helper/Animation";
import Preloader from "../helper/Preloader";
import { useSchoolDetailsContext } from "../context/SchoolDetailsContext";
import { useLoader } from "../context/LoaderContext";
import { fetchSchoolDetails } from "../api/SchoolDetailsApi";
import AboutThree from "../components/AboutThree";
import { useAllDataContext } from "../context/AllDataContext";
import { FetchAllApi } from "../components/FetchAllApi";
import { useLocation } from "react-router-dom";
import FAQInnerOne from "../components/FAQInnerOne";
import WhyEga from "../components/WhyEga";

const AboutTwoPage = () => {
  const { setLoading } = useLoader();
  const { schoolDetailsData, setSchoolDetailsData } = useSchoolDetailsContext();
  const { allData, setAllData } = useAllDataContext();
  const location = useLocation();

  useEffect(() => {
    const section = location.state?.section;
    if (section) {
      const el = document.getElementById(section.toLowerCase());
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [location.state]);

  // const [aboutData, setAboutData] = useState([]);
  // const [bannerData, setbannerData] = useState([]);
  // const [certificateHeaderData, setCertificateHeaderData] = useState([]);
  // const [certificateListData, setCertificateListData] = useState([]);
  // const [joinCommunityHeaderData, setJoinCommunityHeaderData] = useState([]);
  const aboutData = allData.aboutData;
  const bannerData = allData.bannerData;
  // const certificateHeaderData = allData.certificateHeaderData;
  // const certificateListData = allData.certificateListData;
  const visionObjectiveHeader = allData.visionObjectiveHeaderData;
  const joinCommunityHeaderData = allData.joinCommunityHeaderData;
  const visionData = allData.visionData;
  const objectiveData = allData.objectiveData;
  const egaBannerData = allData.allBannerData[0]?.ega_title;
  const whyEgaData = allData.whyEgaData;
  //  useEffect(() => {
  //     setLoading(true);
  //     Promise.all([
  //       fetchHomeAbout(),
  //       fetchAboutBanner(),
  //       fetchcertificateHeader(),
  //       fetchcertificateList(),
  //       fetchjoincommunitiesHeader()
  //     ])
  //       .then(
  //         ([
  //           homeAboutData,
  //           banner,
  //           certificateHeader,
  //           certificateList,
  //           joinCommunityHeader
  //         ]) => {
  //           setAboutData(homeAboutData);
  //           setbannerData(banner);
  //           setCertificateHeaderData(certificateHeader);
  //           setCertificateListData(certificateList);
  //           setJoinCommunityHeaderData(joinCommunityHeader);
  //           setTimeout(() => {
  //             setLoading(false);
  //           }, 500);
  //         }
  //       )
  //       .catch(() => {
  //         console.error("Server Error");
  //         setTimeout(() => {
  //           setLoading(false);
  //         }, 500);
  //       });
  //   }, [setLoading]);
  FetchAllApi({ schoolDetailsData, setAllData, setLoading });

  useEffect(() => {
    if (schoolDetailsData.length === 0) {
      Promise.all([fetchSchoolDetails()])
        .then(([schoolDetailsData]) => {
          setSchoolDetailsData(schoolDetailsData);
        })
        .catch(() => {
          console.error("Server Error");
        });
    }
  }, [schoolDetailsData.length, setSchoolDetailsData]);

  return (
    <>
      {/* Preloader */}
      <Preloader />

      {/* Animation */}
      <Animation />

      {/* HeaderTwo */}
      <HeaderOne />

      {/* Breadcrumb */}
      <Breadcrumb heading={egaBannerData} title={"EGA"} />

      <AboutThree aboutData={aboutData} />

      <FAQInnerOne
        visionObjectiveHeader={visionObjectiveHeader}
        visionData={visionData}
        objectiveData={objectiveData}
      />

      <WhyEga whyEgaData={whyEgaData} />
      {/* FeaturesTwo */}
      {/* <FeaturesTwo /> */}

      {/* InfoSectionOne */}
      <InfoSectionOne bannerData={bannerData} />

      {/* AboutTwo */}
      {/* <AboutTwo /> */}

      {/* CertificateTwo */}
      {/* <CertificateTwo
        certificateHeaderData={certificateHeaderData}
        certificateListData={certificateListData}
      /> */}

      {/* JoinCommunityOne */}
      <JoinCommunityOne joinCommunityHeaderData={joinCommunityHeaderData} />

      {/* TestimonialsTwo */}
      {/* <TestimonialsTwo /> */}

      {/* FooterThree */}
      <FooterThree />
    </>
  );
};

export default AboutTwoPage;
